package com.dotpx.ambient

enum class AmbienceScene(val title: String) {
    RainSchool("雨の廃校"),
    NightTrain("夜行列車の車内"),
    NightShore("海辺の夜"),
    MachineBasement("地下機械室"),
    CaveLake("洞窟の地下湖"),
    VolcanicStation("火山観測所"),
    PowerTower("荒野の送電塔"),
    EveningHigurashi("夕暮れのヒグラシ"),
    AfterRainHousing("雨上がりの団地"),
    MistyMorningCove("朝霧の入り江"),
    OldLibrary("古い木造図書館"),
    RainyUnderpassFire("雨の高架下の焚き火"),
    SunsetRiver("夕暮れの河川敷"),
    StormCedarForest("夕立前の杉林"),
    DerelictHold("廃船の船底"),
    RuinMorning("廃墟の朝"),
    RuinNight("廃墟の夜"),
    AbandonedFactoryIncinerator("廃工場の焼却炉"),
    MorningStationPlaza("朝の駅前広場"),
    FogCedarForest("霧の杉林"),
    RadioSnowfield("雪原の無線小屋"),
    StormBreakwater("嵐の防波堤"),
    WinterCabin("真冬の山小屋"),
    WetAlley("雨上がりの路地"),
    NightLakesideFire("夜の湖畔の焚き火"),
    MountainBrook("山あいの小川"),
    BambooPath("風の通る竹林"),
    SnowboundHut("吹雪の避難小屋"),
    TinRoofRain("トタン屋根の雨"),
    WaterfallPool("滝壺のほとり"),
    LateNightOffice("深夜の換気室"),
    DistantHighway("遠い高速道路"),
    HarborEngine("港に停まる小船"),
    SummerVeranda("夏の縁側"),
    MoonlitStream("月明かりの渓流"),
    SnowForestWalk("雪の森の小径"),
    GreenhouseRain("雨の温室"),
    BehindWaterfall("滝の裏の岩窟"),
    SleepingFerry("夜更けのフェリー"),
    AutumnFootpath("落葉の散歩道"),
    QuietServerRoom("静かなサーバー室"),
    DawnOverpass("夜明けの歩道橋"),
    BambooWaterGarden("竹庭の水辺"),
    BlizzardStation("吹雪の無人駅"),
    CricketMeadow("コオロギの草原"),
    RainyClockRoom("雨と古時計の部屋"),
    MistyBuoy("霧の海の浮標"),
    DeepBambooNight("夜の竹林"),
    WatermillRuins("水車小屋の跡"),
    WinterLighthouse("冬の灯台守の部屋"),
}
